<template>
  <div class="lianxiCenter clearfix">
    <div class="aa">
      <ui-navigation></ui-navigation>
    </div>
    <div class="aboutBox">
      <img class="mb-5" src="/static/images/ditu.jpg" alt="">

      <h2 class="mb-4"><span>Find us.</span></h2>
      <div>
        <p>Unit 806, 8/F, Block E,Shang Ze Da Du Hui 706 Shimen road, Jing kai qu Hefei,China<br>
          合肥市经开区石门路尚泽大都会E座</p>
      </div>
      <hr class="mt-4">
      <h2 class="mb-4"><span>Call us.</span></h2>
      <div>
        <p>0551-63750711</p>
      </div>
      <hr class="mt-4">
      <h2 class="mb-4"><span>Email us.</span></h2>
      <div>
        <p class="mb-1"><b>SALES &amp; MARKETING DEPARTMENT</b></p>
        <p class="mb-1">销售和市场部</p>
        <p>denise@xuediaudio.com</p>
      </div>
      <div>
        <p class="mb-1"><b>TECHNICAL DEPARTMENT</b></p>
        <p class="mb-1">技术支持</p>
        <p>yeti@xuediaudio.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import Navigation from '@/components/about/Navigation.vue';

export default {
  name: 'lianxiCenter',
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
    'ui-navigation': Navigation
  },
  mounted() {
    $('html').removeClass('scrollHide');
  }
}
</script>

<style scoped lang='less'>
.lianxiCenter{
  display: flex;
  div.aa{
    width: 200px;
    margin-right: 30px;
  }
  div.aboutBox{
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 30px;
    img{
      width: 100%;
      border-radius: 10px;
    }
    h2{
      font-size: 32px;
      color: #FF7B00;
    }
  }
}
@media (max-width: 992px) {
  .lianxiCenter{
    flex-direction: column;
    div.aa{
      margin: 0;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Lianxi.vue